module.exports = __webpack_public_path__ + "static/media/font_regular.b8a6ec09.woff";